module.exports = __webpack_public_path__ + "static/media/yumin.78525377.ttf";